// src/components/Unauthorized.js
import React from 'react';

const Unauthorized = () => {
  return <div>You do not have permission to view this page.</div>;
};

export default Unauthorized;
